import { z } from 'zod';
import { uuidSchema } from '../api';
const listCursorSchema = uuidSchema.optional();
const pageLimitSchema = z.coerce.number().int().min(1).max(100).default(25);
export const NPHIES_ELIGIBILITY_VALID_DAYS_KEY = 'nphiesEligibilityValidDays';
export const NPHIES_ELIGIBILITY_VALID_DAYS_DEFAULT = 30;
export const NPHIES_ELIGIBILITY_VALID_DAYS_MIN = 1;
export const NPHIES_ELIGIBILITY_VALID_DAYS_MAX = 365;
export const branchPayerCreateSchema = z.object({
    branchId: uuidSchema.optional(),
    payerId: uuidSchema,
    active: z.boolean().default(true),
    cchiNo: z.string().trim().max(40).optional(),
    nphiesLicenseOverride: z.string().trim().max(60).optional(),
    defaultPlanId: uuidSchema.optional(),
});
export const branchPayerUpdateSchema = z
    .object({
    active: z.boolean(),
    cchiNo: z.string().trim().max(40).nullable(),
    nphiesLicenseOverride: z.string().trim().max(60).nullable(),
    defaultPlanId: uuidSchema.nullable(),
})
    .partial()
    .refine((input) => Object.keys(input).length > 0, 'Change at least one field');
export const branchPayerListQuerySchema = z.object({
    branchId: uuidSchema.optional(),
    payerId: uuidSchema.optional(),
    limit: pageLimitSchema,
    cursor: listCursorSchema,
});
export const ELIGIBILITY_STATES = ['valid', 'expired', 'never'];
export const ELIGIBILITY_SIDES = ['servicedPeriodEnd', 'checkedPlusDays', 'endOfYear'];
export const eligibilitySessionQuerySchema = z.object({
    patientId: uuidSchema,
    payerId: uuidSchema.optional(),
});
export const eligibilityExpireSchema = z.object({
    reason: z.string().trim().max(300).optional(),
});
export const DISCOVERY_BASES = ['no_policy_on_file', 'not_in_force'];
export const eligibilityDiscoverySchema = z.object({
    patientId: uuidSchema,
    payerId: uuidSchema,
    branchId: uuidSchema.optional(),
    hasInsuranceButNoPolicy: z.boolean().default(false),
    serviceDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});
export const eligibilityHistoryQuerySchema = z.object({
    limit: pageLimitSchema,
    cursor: listCursorSchema,
});
export const LINE_COVERAGE_STATES = ['covered', 'self_pay', 'pending_auth'];
export const AUTH_LINE_ANSWERS = ['approved', 'partial', 'rejected', 'pended', 'pending'];
export const patientInsuranceQuerySchema = z.object({
    limit: pageLimitSchema,
    cursor: listCursorSchema,
    payerId: uuidSchema.optional(),
});
export const CLAIM_BLOCKING_KINDS = ['invoice_unpaid', 'encounter_open', 'admission_open', 'nothing_approved'];
export function parseClaimBlockingItem(details) {
    const entry = details?.find((detail) => detail.path === 'blockingItem');
    if (!entry)
        return null;
    try {
        return JSON.parse(entry.message);
    }
    catch {
        return null;
    }
}
export const ARCHIVE_ENTITY_KINDS = ['pre_authorization', 'claim', 'patient_coverage', 'reconciliation', 'communication', 'poll'];
export const ARCHIVE_VIEWS = ['rows', 'pairs'];
export const nphiesArchiveQuerySchema = z.object({
    entityType: z.enum(ARCHIVE_ENTITY_KINDS).optional(),
    entityId: uuidSchema.optional(),
    view: z.enum(ARCHIVE_VIEWS).default('rows'),
    cursor: listCursorSchema,
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=insurance-flow.js.map